import styled from "styled-components"

import Button from "./Button"

const TableButton = styled(Button)`
  border-radius: 10px;
`

export default TableButton
